import React from 'react';
// import GoogleOneTapLogin from 'react-google-one-tap-login';
// import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
// import axios from 'axios';
import Cookies from 'universal-cookie';
import { LoadingButton } from '@mui/lab';
// import { devLog, _route } from '../../../utils';
import { _route } from '../../../utils';
// import { AUTH_POST_LOGIN_WITH_GOOGLE } from '../../../config/api';
// import { googleSsoClientID } from '../../../config';
// import GoogleLogo from '../../../assets/icons/google.svg';
// import AmazonLogo from '../../../assets/icons/amazon.svg';
import AmazonLogoBlack from '../../../assets/icons/amazonblack.svg';

const buttonStyles = {
  display: 'flex',
  alignItems: 'center',
  borderRadius: '10px',
  boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
  padding: '15px 14px',
  height: '63px',
  width: '258px',
  color: '#fff',
  transition: '0.2s',
  marginTop: '8px',
  fontSize: '16px',
  fontWeight: '500',
  backgroundColor: '#5433FF',
  borderColor: '#5433FF',
  border: '1px solid #5433FF',
  fontFamily: 'Inter',
  letterSpacing: '0',
  textTransform: 'inherit',
  '&:hover': {
    backgroundColor: '#5433FF',
    borderColor: '#5433FF',
    opacity: '0.9',
    boxShadow: '0 4px 11px rgb(0 0 0 / 11%)',
  },
  '&:focus': {
    backgroundColor: '#5433FF',
    borderColor: '#5433FF',
    opacity: '0.9',
    boxShadow: '0 4px 11px rgb(0 0 0 / 11%)',
  },
  '&:visited': {
    backgroundColor: '#5433FF',
    borderColor: '#5433FF',
    opacity: '0.9',
    boxShadow: '0 4px 11px rgb(0 0 0 / 11%)',
  },
};

// function LoginOption({ btnText }) {
function LoginOption() {
  const routeParams = useLocation();
  let searchParamsData = new URLSearchParams(routeParams.search);
  searchParamsData = { autopilot: searchParamsData.get('autopilot') || false };
  const cookies = new Cookies();
  if (cookies.get('autopilot')) {
    searchParamsData.autopilot = true;
  }
  const { signInWithAmazon, signInWithGoogle } = useSelector(({ features }) => features);
  // const prefixLoginOptions = btnText;

  // const createProfile = async (data) => {
  //   try {
  //     const response = await axios.post(AUTH_POST_LOGIN_WITH_GOOGLE, {
  //       ...data,
  //       routeParams: searchParamsData,
  //     });
  //     let href = _route('growz.overview');
  //     if (!response?.data?.user?.mobile) {
  //       href = _route('finishSignUp');
  //     } else if (response.data.stores !== 0) {
  //       href = _route('stores');
  //     }
  //     window.location.href = href;
  //   } catch (e) {
  //     toast.error('Unable to sign in with google');
  //   }
  // };

  if (!signInWithAmazon && !signInWithGoogle) return '';
  const routeParamsValue = cookies.get('autopilot') ?? false;

  return (
    <>
      {/* <div className="diveder_line_auth">
        <span className="diveder_line_auth_text">Or</span>
      </div> */}
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        {/* {signInWithGoogle && (
          <>
            <LoadingButton
              fullWidth
              size="large"
              onClick={() => (window.location.href = _route('sso.google.login'))}
              sx={buttonStyles}
              variant="contained"
            >
              <img src={GoogleLogo} style={{ marginRight: '0.6rem' }} /> {prefixLoginOptions} with Google
            </LoadingButton>
            <GoogleOneTapLogin
              onError={devLog}
              onSuccess={createProfile}
              googleAccountConfigs={{ client_id: googleSsoClientID }}
              style={{ paddingTop: '10px' }}
            />
          </>
        )} */}
        {signInWithAmazon && (
          <LoadingButton
            fullWidth
            size="large"
            onClick={() => (window.location.href = _route('sso.amazon.elevate', { value: routeParamsValue }))}
            sx={buttonStyles}
            variant="contained"
          >
            <img src={AmazonLogoBlack} style={{ marginRight: '0.6rem' }} /> Sign In with Amazon
            {/* <img src={AmazonLogo} style={{ marginRight: '0.6rem' }} /> {prefixLoginOptions} with Amazon */}
          </LoadingButton>
        )}
      </div>
    </>
  );
}
export default LoginOption;
